
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({

	state: {

		/*
			General
		*/

		client: {},

		account: {},

		provider: {},

		platform: {},

		//apiURLs: {},

		accessToken: null,

		embed: false,

		//brandColour: null,

		displayComponentName: null,

		paymentStep: 1,

		causes: [],

		user: {},

		jwt: null,

		transactionResponse: {},

		recurringPaymentResponse: {},

		receiptNumber: null,

		cancelRecurring: null,

		showReceiptBackButton: true,

		showFooter: false,

		errorScreen: {},

		/*
			
			Properties that will be used as part of the
			transaction payload.
			
		*/

		selectedCause: {},

		amount: 0,

		notes: "",

		userWillPayTheFees: 0,

		frequency: {
			type: "one_time",
			interval: "weekly",
			startDate: new Date(),
		},

		mobileNumber: null,

		mobileNumberValidated: null,

		isMobileNumberValidated: false,

		address: {},

		donationCauses: [],

		from_content_type: "",

		from_content_id: "",

		error3DS: "",

		iframeUrl: {},


	},

	getters: {

		client(state, getters) {
			return state.client;
		},

		account(state, getters) {
			return state.account;
		},

		provider(state, getters) {
			return state.provider;
		},

		platform(state, getters) {
			return state.platform;
		},

		requestHeaders(state, getters) {

			const headers = {
				"Content-Type": "application/x-www-form-urlencoded",
				"Vinteract-Access-Token": getters.accessToken,
				"Vinteract-Platform-Token": "Zm9ybQ=="
			};

			if (getters.jwt) {
				headers["Authorization"] = `Bearer ${getters.jwt}`;
			}

			return headers;

		},

		requestHeaders2(state, getters) {

			const headers = {
				"Vinteract-Access-Token": getters.accessToken,
				"Vinteract-Platform-Token": "Zm9ybQ=="
			};

			if (getters.jwt) {
				headers["Authorization"] = `Bearer ${getters.jwt}`;
			}

			return headers;

		},

		smsVerificationApiUrl() {
			if (process.env.NODE_ENV == "production") {
				return "https://atoms.vinteract.com.au/sms";
			}
			return "http://atoms.vinteract.net.au/sms";
		},

		accessToken(state, getters) {
			return state.accessToken;
		},

		embed(state, getters) {
			return state.embed;
		},

		brandColour(state, getters) {
			if (state.account.hasOwnProperty("settings")) {
				return state.account.settings.brand_colour;
			}
			return "black";
		},

		displayComponentName(state, getters) {
			return state.displayComponentName;
		},

		causes(state, getters) {
			return state.causes;
		},

		user(state, getters) {
			return state.user;
		},

		jwt(state, getters) {
			return state.jwt;
		},

		userPhoneNumber(state, getters) {
			if (state.user.hasOwnProperty("phone") && state.user.phone) {
				return state.user.phone.toString();
			}
			return "";
		},

		userAddressString(state, getters) {
			if (getters.address.hasOwnProperty("street_1") && getters.address.street_1 != null) {
				return `${getters.address.street_1}, ${getters.address.city} ${getters.address.state}, ${getters.address.country}`;
				//} else if (getters.address.hasOwnProperty("city") && getters.address.city != "") {
				//return `${getters.address.city} ${getters.address.state}, ${getters.address.country}`;
			}
			return "";
		},

		userIsLoggedIn(state, getters) {
			return state.user.hasOwnProperty("uuid");
		},

		paymentStepComponentName(state, getters) {
			return `PaymentFormStep${state.paymentStep}`;
		},
		recurringPaymentResponse: {},

		transactionResponse(state, getters) {
			return state.transactionResponse;
		},

		recurringPaymentResponse(state, getters) {
			return state.recurringPaymentResponse;
		},

		receiptNumber(state, getters) {
			return state.receiptNumber;
		},

		cancelRecurring(state, getters) {
			return state.cancelRecurring;
		},

		showReceiptBackButton(state, getters) {
			return state.showReceiptBackButton;
		},

		showFooter(state, getters) {
			return state.showFooter;
		},

		errorScreen(state, getters) {
			return state.errorScreen;
		},

		/*
			
			Properties that will be used as part of the
			transaction payload.
			
		*/

		selectedCause(state, getters) {
			return state.selectedCause;
		},

		amount(state, getters) {
			return state.amount;
		},

		notes(state, getters) {
			return state.notes;
		},

		userIsPayingTheFees(state, getters) {
			if (getters.selectedCause.who_pays_fees === 1) {
				return state.userWillPayTheFees;
			} else if (getters.selectedCause.who_pays_fees === 2) {
				return true;
			}
			return false;
		},

		creditCardFee(state, getters) {

			if (getters.selectedCause.who_pays_fees === 0) {
				return 0;
			}

			if (!("information" in getters.account)) {
				return 0;
			}

			const amount = state.amount;

			const fee_percentage = getters.account.information.platform_fee_percentage;
			const fee_fixed = (getters.account.information.platform_fee_fixed / 100);

			const fee_multiplier = ((100 - fee_percentage) / 100);

			const amount_with_fees = ((amount / fee_multiplier) + fee_fixed);

			return (amount_with_fees - amount);

		},

		finalAmount(state, getters) {
			if (getters.userIsPayingTheFees) {
				return Number(getters.amount + getters.creditCardFee).toFixed(2);
			}
			return Number(getters.amount).toFixed(2);
		},

		frequency(state, getters) {
			return state.frequency;
		},

		mobileNumber(state, getters) {
			if (state.mobileNumber) {
				return state.mobileNumber.toString();
			} else if (getters.user.phone) {
				return getters.user.phone.toString();
			}
			return "";
		},

		mobileNumberValidated(state, getters) {
			return state.mobileNumberValidated;
		},

		isMobileNumberValidated(state, getters) {
			return state.isMobileNumberValidated;
		},

		address(state, getters) {
			return state.address;
		},

		donationCauses(state, getters) {
			return state.donationCauses;
		},

		from_content_type(state, getters) {
			return state.from_content_type;
		},

		from_content_id(state, getters) {
			return state.from_content_id;
		},

		error3DS(state, getters) {
			return state.error3DS;
		},

		iframeUrl(state, getters) {
			return state.iframeUrl;
		},

		userWillPayTheFees(state, getters) {
			return state.userWillPayTheFees;
		},

	},

	mutations: {

		client(state, client) {
			state.client = client;
		},

		account(state, account) {
			state.account = account;
		},

		provider(state, provider) {
			state.provider = provider;
		},

		platform(state, platform) {
			state.platform = platform;
		},

		/*apiURLs(state, apiURLs) {
			state.apiURLs = apiURLs;
		},*/

		accessToken(state, accessToken) {
			state.accessToken = accessToken;
		},

		embed(state, embed) {
			state.embed = embed;
		},

		/*brandColour(state, brandColour) {
			state.brandColour = brandColour;
		},*/

		displayComponentName(state, displayComponentName) {
			state.displayComponentName = displayComponentName;
		},

		incrementPaymentStep(state) {
			state.paymentStep++;
		},

		setPaymentStep(state, step) {
			state.paymentStep = step;
		},

		causes(state, causes) {
			state.causes = causes;
		},

		user(state, user) {
			state.user = user;
		},

		jwt(state, jwt) {
			state.jwt = jwt;
		},

		transactionResponse(state, transactionResponse) {
			state.transactionResponse = transactionResponse;
		},

		recurringPaymentResponse(state, recurringPaymentResponse) {
			state.recurringPaymentResponse = recurringPaymentResponse;
		},

		receiptNumber(state, receiptNumber) {
			state.receiptNumber = receiptNumber;
		},

		cancelRecurring(state, cancelRecurring) {
			state.cancelRecurring = cancelRecurring;
		},

		showReceiptBackButton(state, showReceiptBackButton) {
			state.showReceiptBackButton = showReceiptBackButton;
		},

		showFooter(state, showFooter) {
			state.showFooter = showFooter;
		},

		errorScreen(state, errorScreen) {
			state.errorScreen = errorScreen;
		},

		resetPaymentForm(state) {

			state.paymentStep = 1;

			state.transactionResponse = {};

			state.receiptNumber = {};

			state.selectedCause = {};

			state.amount = 0;

			state.notes = "";

			state.frequency = {
				type: "one_time",
				interval: "weekly",
				startDate: new Date(),
			};

			state.mobileNumber = null;

			state.mobileNumberValidated = null;

			state.isMobileNumberValidated = false;

		},

		/*
			
			Properties that will be used as part of the
			transaction payload.
			
		*/

		amount(state, amount) {
			state.amount = amount;
		},

		notes(state, notes) {
			state.notes = notes;
		},

		mobileNumber(state, mobileNumber) {
			state.mobileNumber = mobileNumber;
		},

		mobileNumberValidated(state, mobileNumberValidated) {
			state.mobileNumberValidated = mobileNumberValidated;
		},

		isMobileNumberValidated(state, isMobileNumberValidated) {
			state.isMobileNumberValidated = isMobileNumberValidated;

			clearTimeout(timeout);

			var timeout = setTimeout(function () {
				state.isMobileNumberValidated = false;
			}, 60000);
		},

		selectedCause(state, selectedCause) {
			state.selectedCause = selectedCause;
		},

		address(state, address) {
			state.address = address;
		},

		donationCauses(state, donationCauses) {
			state.donationCauses = donationCauses;
		},

		from_content_type(state, from_content_type) {
			state.from_content_type = from_content_type;
		},

		from_content_id(state, from_content_id) {
			state.from_content_id = from_content_id;
		},

		error3DS(state, error3DS) {
			state.error3DS = error3DS;
		},

		iframeUrl(state, iframeUrl) {
			state.iframeUrl = iframeUrl;
		},

		userWillPayTheFees(state, userWillPayTheFees) {
			state.userWillPayTheFees = userWillPayTheFees;
		},

		frequency(state, frequency) {
			state.frequency = frequency;
		},

	},

});